/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/jsx-curly-brace-presence */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */

import React, { useCallback, useEffect, useState } from "react";

import "./styles.scss";
import { TState, TItem } from "./types";
import { Option } from "./components";

interface ISelectProps {
  onChange: (item: TItem) => void;
  placeholder: string;
  disabled: boolean | undefined;
  style: React.CSSProperties;
  items: TItem[];
  reset: boolean;
  selected: string;
  errorLabel?: React.Component;
}

const SelectBox: React.FC<ISelectProps> = ({
  onChange,
  placeholder,
  items,
  disabled,
  style,
  selected,
  reset,
  errorLabel,
}) => {
  const initState = {
    // @ts-ignore
    items: [],
    showItems: false,
  };
  const [state, setState] = useState<TState>(initState);

  const dropDownCallback = useCallback(() => {
    if (disabled || !items.length) return;

    setState((prevState) => {
      return {
        ...prevState,
        showItems: !prevState.showItems,
      };
    });
  }, [disabled]);

  const selectItem = (item: TItem) => {
    setState((prevState) => ({
      ...prevState,
      showItems: false,
    }));
    onChange(item);
  };

  useEffect(() => {
    setState((prevState) => ({
      ...prevState,
      items,
      showItems: false,
    }));
  }, [items.length]);

  useEffect(() => {
    if (reset) {
      setState({
        items,
        showItems: false,
      });
    }
  }, [reset]);

  return (
    <div
      style={style}
      className={`${disabled ? "select-box--box-disable" : "select-box--box"}`}
    >
      <div
        className={`${
          state.showItems ? "select-box--hide" : "select-box--container"
        }`}
      >
        <div
          className={`${
            state.showItems && "select-box--selected-item__active"
          } select-box--selected-item`}
          onClick={dropDownCallback}
        >
          {selected || placeholder}
        </div>
        <div className="select-box--arrow" onClick={dropDownCallback} />

        <div
          style={{ display: state.showItems ? "block" : "none" }}
          className={"select-box--items"}
        >
          {state.items.map((item) => (
            <Option
              key={item.id}
              item={item}
              onChange={selectItem}
              isSelected={selected === item.value}
            />
          ))}
        </div>
      </div>
      {errorLabel}
    </div>
  );
};
export default SelectBox;
